var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg079RightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.456,213.569L200.434,17.547c-23.397-23.397-61.466-23.397-84.862,0C104.238,28.881,97.996,43.95,97.996,59.978 v392.044c0,16.028,6.242,31.096,17.576,42.431C127.27,506.15,142.636,512,158.003,512c15.366,0,30.732-5.85,42.431-17.547 c7.812-7.811,7.811-20.475,0-28.287c-7.811-7.812-20.475-7.812-28.287,0c-7.799,7.799-20.488,7.799-28.287,0 c-3.777-3.778-5.859-8.801-5.859-14.144V59.978c0-5.343,2.081-10.365,5.859-14.144c7.799-7.799,20.488-7.799,28.287,0 l196.022,196.022c7.799,7.799,7.799,20.488,0,28.287l-126.73,126.73c-7.812,7.811-7.811,20.475,0,28.287 c7.811,7.812,20.475,7.812,28.287,0l126.731-126.729C419.853,275.034,419.853,236.966,396.456,213.569z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg079RightArrow);
export default __webpack_public_path__ + "static/media/079-right-arrow.94f2e6a1c28dc56045d09acf2af1db37.svg";
export { ForwardRef as ReactComponent };